/** Dev2 inbound Twilio numbers — update here when Ops rotates test lines (not fp-api env). */
export const DEV2_TWILIO_TO_BY_DEVICE = {
  onx: '+14067976900',
  oxr: '+16199754632',
};

export const DEV2_DEVICE_TYPE_OPTIONS = [
  { value: 'onx', label: 'onX' },
  { value: 'oxr', label: 'OXR' },
];

export function defaultDev2DeviceTypeForParent(parent) {
  const p = String(parent || '').trim().toUpperCase();
  if (p === 'ONX MAPS') return 'onx';
  if (p === 'OXR DTC') return 'oxr';
  return 'onx';
}

export function dev2TwilioToForDeviceType(deviceType) {
  return DEV2_TWILIO_TO_BY_DEVICE[deviceType] || DEV2_TWILIO_TO_BY_DEVICE.onx;
}

export const DEV2_ONX_BUBBLE_ID = 'onX App';

/** Pulse device bubbleId (`bubbleId` on the trigger API — the device under test, not the time window). */
export function defaultBubbleIdForDeviceType(deviceType) {
  if (deviceType === 'onx') return DEV2_ONX_BUBBLE_ID;
  return '';
}

/** fp-api trigger `step` values — run one hop without the full pipeline. */
export const DEV2_TRIGGER_STEPS = {
  schedule: 'schedule',
  validate: 'validate',
  sos: 'inboundTwilioSos',
};

/** `testingDate` is UTC wall time, ISO without Z/offset (Device Tests list convention). */
export const DEV2_TESTING_DATE_TIMEZONE = 'UTC';

/**
 * `testingDate` for schedule — current instant as UTC components, no offset suffix.
 */
export function dev2TestingDateForSchedule() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}

/** Best-effort E.164 for member phone fields from Global Search. */
export function normalizeE164Phone(phone) {
  const raw = String(phone ?? '').trim();
  if (!raw) return '';
  if (raw.startsWith('+')) {
    const digits = raw.slice(1).replace(/\D/g, '');
    return digits ? `+${digits}` : '';
  }
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return digits ? `+${digits}` : '';
}
